exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".menu-form .modal-lg{max-width:95%}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/combo/ModalStore.vue"],"names":[],"mappings":"AACA,qBACE,aAAe,CAChB","file":"ModalStore.vue","sourcesContent":["\n.menu-form .modal-lg{\n  max-width: 95%;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96b42cf4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/combo/ModalStore.vue
// module id = 1610
// module chunks = 0